export default __webpack_public_path__ + "static/media/spheres.f993efa2.mp3";